// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1I5pv","title":"ClientInsurance_title__2fFDB","itemText":"ClientInsurance_itemText__vkW-d"};